/**
 * Parse a stringified object
 *
 * @param   { string } stringifiedObject : stringified object
 * @returns { object }                   : parsed object
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function parseObject(stringifiedObject: string) {
  if (stringifiedObject === '') {
    return {};
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return JSON.parse(stringifiedObject);
}

/**
 * Stringifies an object
 *
 * @param   { object } objectToStringify  : Object that should be stringify
 * @returns { string }                    : stringified object
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function stringifyObject(objectToStringify: object) {
  if (Object.keys(objectToStringify).length === 0) {
    return '';
  }

  return JSON.stringify(objectToStringify);
}

/**
 * Split up a date range string into an object with a start and an end
 * Example dateRangeString: "2020-10-01:2020-10-31"
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function parseDateRangeString(dateRangeString: string) {
  return {
    start: dateRangeString.split(':')[0],
    end: dateRangeString.split(':')[1],
  };
}
